<template>
  <v-row justify="center">

        <v-btn
          v-if="this.button_style === 0"
          class="text--darken-3"
          @click.stop="dialog = true"
          color="white"
          text
        >
        {{this.label}}
        </v-btn>

        <v-btn
          v-if="this.button_style === 1"
          class="light-blue darken-4"
          @click.stop="dialog = true"
          color="white"
          text
        >
        {{this.label}}
        </v-btn>

        <!-- <v-checkbox 
          v-if="this.button_style === 2"
          v-model="checked"
          text>
          Acepto los términos y condiciones   
        </v-checkbox> -->

    <v-dialog
      v-model="dialog"
      max-width="720"
    >
      <v-card>

        <v-card-text>
          <tutorials :tutorial="tutorial" />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="close"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import Tutorials from '@/views/dashboard/tutorials/DialogTutorial'

  export default {
    components: {
      Tutorials,
    },
    props: {
      tutorial: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      button_style: {
        type: Number,
        default: 0,
      },
    },
    data () {
      return {
        dialog: false,
      }
    },
    methods: {
      close () {
        this.dialog = false
      },
    },
  }
</script>
